import React from 'react'
import ForgotPassword from '../components/accounts/reset_password/forgot_password'

export default props => <ForgotPassword {...props} />
